<template>
	<div class="col-span-full grid grid-cols-2 gap-x-4 gap-y-8 lg:grid-cols-4">
		<template v-for="brand in sortedBrands" :key="brand.uuid">
			<sb-brand-card :blok="brand"></sb-brand-card>
		</template>
	</div>
</template>

<script setup lang="ts">
import type {ISbStoryData} from "storyblok-js-client";

import {useStoryblokStoriesList} from "@pkg/shared/composables/use-storyblok-stories-list";

const properties = defineProps<{
	blok: ISbStoryData[];
}>();

const brandUuids = properties.blok.join(",");

const {t} = useI18n();

const {
	data: {value: brands},
} = await useStoryblokStoriesList(`brands-${brandUuids}`, {
	starts_with: `${t("storyblok.brands-page")}/`,
	per_page: 50,
	by_uuids: brandUuids,
	sort_by: "position:desc",
});

const sortedBrands = computed(() =>
	properties.blok.map(
		(uuid) =>
			brands.find((brand) => brand.uuid === uuid.toString()) as ISbStoryData,
	),
);
</script>
